export default __webpack_public_path__ + "static/media/david_timisoriana.d9b6cb22.jpg";